__turbopack_context__.v({
  "benefits": "GiftCard-module-scss-module__P-8ljq__benefits",
  "chooseShopLink": "GiftCard-module-scss-module__P-8ljq__chooseShopLink",
  "giftsPage": "GiftCard-module-scss-module__P-8ljq__giftsPage",
  "imgWrap": "GiftCard-module-scss-module__P-8ljq__imgWrap",
  "linkWrap": "GiftCard-module-scss-module__P-8ljq__linkWrap",
  "note": "GiftCard-module-scss-module__P-8ljq__note",
  "purchaseWrap": "GiftCard-module-scss-module__P-8ljq__purchaseWrap",
  "shopLink": "GiftCard-module-scss-module__P-8ljq__shopLink",
  "subtitle": "GiftCard-module-scss-module__P-8ljq__subtitle",
  "title": "GiftCard-module-scss-module__P-8ljq__title",
});
